/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */
import { Injectable } from "@angular/core";
import { RdsLicenseInfoService } from "../../../shared/common/service/rds-license-info.service";

@Injectable({
   providedIn: "root"
})
export class HorizonRdsLicenseInfoService extends RdsLicenseInfoService {
   public getRdsLicense = () => {
      return "";
   };
   public isRdsLicenseEnabled = () => {
      return false;
   };
}
